<template>
  <!-- 机台预览，单个机台组件 -->
  <el-card
    style="width:274px"
    :class="getCardHeadClass(item)"
    :body-style="getCardBodyStyle(item)"
  >
    <div slot="header" class="header">
      <el-tooltip
        :content="item.machineNumber + '#' + '(' + item.workShop + ')'"
        placement="bottom"
      >
        <div class="machineNumber">{{ item.machineNumber + "#" }}</div>
      </el-tooltip>
      <div>
        <el-button
          size="mini"
          style="color: #fff;background-color: rgba(255, 255, 255, 0);"
          @click="
            clickWorkOrderDetails(item.machineId, item.machineNumber, item.machineKind)
          "
          >预警</el-button
        >
        <el-button
          size="mini"
          style="color: #fff;background-color: rgba(255, 255, 255, 0);"
          @click="
            goToMachineDetail(item.machineNumber, item.machineId, item.machineKind)
          "
          >详情</el-button
        >
      </div>
    </div>
    <div>
      <p>产品名称：{{ item.order.name }}</p>
      <p>开机效率：{{ item.availability + "%" }}</p>
      <p v-show="item.machineKind == 0">
        生产进度：{{
          (item.order.orderFinishWeight == null ||
          item.order.orderFinishWeight == undefined
            ? "0"
            : (item.order.orderFinishWeight / 1000).toFixed(2) + "kg") +
            "/" +
            (item.order.orderWeight == null ||
            item.order.orderWeight == undefined
              ? "1"
              : (item.order.orderWeight / 1000).toFixed(2) + "kg")
        }}
        <el-progress
          :format="format"
          :percentage="
            getProgress(item.order.orderFinishWeight, item.order.orderWeight)
          "
        ></el-progress>
      </p>
      <p v-show="item.machineKind == 1">
        生产进度：{{
          (item.order.orderFinishedHeads == null ||
          item.order.orderFinishedHeads == undefined
            ? "0"
            : item.order.orderFinishedHeads) +
            "/" +
            (item.order.orderHeads == null || item.order.orderHeads == undefined
              ? "1"
              : item.order.orderHeads)
        }}
        <el-progress
          :format="format"
          :percentage="
            getProgress(item.order.orderFinishedHeads, item.order.orderHeads)
          "
        ></el-progress>
      </p>
      <p v-show="item.machineKind == 1">盘头数：{{ item.heads + "个" }}</p>
      <p v-show="item.machineKind == 1">
        停机时长：{{ timeChange(item.userTime - item.todayRunTime) }}
      </p>
      <p v-show="item.machineKind == 0">
        疵点个数：{{ item.todayDefectCounts + "个" }}
      </p>
      <p v-show="item.machineKind == 0">停机次数：{{ item.todayHaltCounts + "次" }}</p>
      <p v-show="item.machineKind == 0">机台转速：{{ item.realSpeed + "转/分钟" }}</p>
      <p v-show="item.machineKind == 1">机台转速：{{ item.realSpeed + "m/min" }}</p>
      <p v-show="item.machineKind == 0">当班挡车：{{ getWorkInfo() }}</p>
      <p v-show="item.machineKind == 1">整经工：{{ getWorks() }}</p>
      <p>持续时间：{{ getStatusContinueTime() }}</p>
    </div>
  </el-card>
</template>
<script>
export default {
  props: {
    item: {
      default: {},
    },
  },
  data() {
    return {
      // machineStateColor: ['#f29100', '#19be6b', '#19be6b', '#f29100', '#f29100', '#dd6161', '#dd6161',
      //     '#dd6161',
      //     '#f29100', '#f29100', '#f29100', '#f29100', '#f29100', '#f29100', '#f29100', '#f29100'
      // ],
      // machineStateType: ['warning', 'success', 'success', 'warning', 'warning', 'danger', 'danger', 'danger',
      //     'warning', 'warning', 'warning', 'warning', 'warning', 'warning', 'warning', 'warning'
      // ],
      // machineStateText: ['待机', '异常开机', '生产中', '手动停机', '超时停机', '维修请求', '维修超时', '维修中', '上料请求',
      //     '上料超时', '上料中', '穿纱请求', '穿纱超时', '穿纱中', '管理查看', '未知人员'
      // ]

      machineStateColor: [
        "#f29100",
        "#19be6b",
        "#19be6b",
        "#f29100",
        "#f29100",
        "#dd6161",
        "#dd6161",
        "#dd6161",
        "#f29100",
        "#f29100",
        "#f29100",
        "#f29100",
        "#f29100",
        "#f29100",
        "#f29100",
        "#f29100",
        "#f29100",
        "#f29100",
        "#f29100",
        "#f29100",
        "#f29100",
      ],
      machineStateType: [
        "warning",
        "success",
        "success",
        "warning",
        "warning",
        "error",
        "error",
        "error",
        "warning",
        "warning",
        "warning",
        "warning",
        "warning",
        "warning",
        "warning",
        "warning",
        "warning",
        "warning",
        "warning",
        "warning",
        "warning",
      ],
      machineStateText: [
        "待机",
        "异常运行",
        "运行",
        "停机",
        "停机超时",
        "维修请求",
        "维修超时",
        "维修",
        "盘头请求",
        "盘头请求超时",
        "盘头中",
        "穿纱请求",
        "穿纱超时",
        "穿纱中",
        "其他状态",
        "未知",
        "未知",
        "未知",
        "维修结束",
        "盘头结束",
        "穿纱结束",
      ],
    };
  },
  methods: {
    getWorks() {
      const item = this.item;
      if (item.workers.length == 0) {
        return "暂无数据";
      } else {
        if (item.workers[0].role == 32) {
          return item.workers[0].username;
        }
      }
    },
    // 根据状态，返回卡片的body样式
    getCardBodyStyle(item) {
      const styleObj = {
        color: "#ffffff",
        padding: "2px 0px 2px 12px",
      };
      if (item.pairingStateEnum === 0) {
        styleObj["background-color"] = "#f29100";
      } else if (item.machineWorkingState === -1) {
        styleObj["background-color"] = "#82848a";
      } else {
        const stateColor = this.machineStateColor[item.machineWorkingState];
        styleObj["background-color"] = stateColor || this.machineStateColor[0];
      }
      return styleObj;
    },
    // 根据状态返回卡片的head样式
    getCardHeadClass(item) {
      if (item.pairingStateEnum === 0) {
        return {
          orange_back: true,
        };
      } else {
        if (item.machineWorkingState === -1) {
          return {
            gray_back: true,
          };
        } else if (
          item.machineWorkingState === 1 ||
          item.machineWorkingState === 2
        ) {
          return {
            green_back: true,
          };
        } else if (
          item.machineWorkingState === 5 ||
          item.machineWorkingState === 6 ||
          item.machineWorkingState === 7
        ) {
          return {
            red_back: true,
          };
        } else {
          return {
            orange_back: true,
          };
        }
      }
    },
    // 根据状态，返回type
    getBodyTagType(item) {
      if (item.machineWorkingState === -1) {
        return "info";
      } else if (
        item.machineWorkingState === 1 ||
        item.machineWorkingState === 2
      ) {
        return "success";
      } else if (
        item.machineWorkingState === 5 ||
        item.machineWorkingState === 6 ||
        item.machineWorkingState === 7
      ) {
        return "danger";
      } else {
        return "warning";
      }
    },
    // 因为title 是机台加车间，可能会太长，所以超过8位就截取
    // getCardHeadTitle(machineNumber, workShop) {
    //   let mergeString = machineNumber + "(" + workShop + ")";
    //   if (mergeString.length > 8) {
    //     mergeString = mergeString.substring(0, 8) + "..";
    //   }
    //   return mergeString;
    // },
    // 去机台图表界面（趋势图、状态图、时序图）
    goToMachineDetail(number, id, machineKind) {
      this.$router.push(`machinePreview/machineChart/${number}/${id}/${machineKind}`);
    },
    // 展示机台所在生产工单信息的弹框
    clickWorkOrderDetails(machineId, num, machineKind) {
      this.$emit("click-work-order", machineId, num, machineKind);
    },
    format(percentage) {
      return percentage >= 100 ? "100%" : `${percentage}%`;
    },
    getProgress(val1, val2) {
      if (val1 == null || val2 == null) {
        return 0;
      }
      return ((val1 / val2) * 100).toFixed(0);
    },

    //显示 状态持续时间 -sta
    getStatusContinueTime() {
      const item = this.item;
      let outputString = "";
      switch (item.machineWorkingState) {
        case -1: //离线
          outputString =
            "离线 (" +
            this.utils.milliToHour(new Date().getTime() - item.unixTime) +
            "小时)";
          break;
        default:
          // console.log('item.workingStateKeepTime=', item.workingStateKeepTime)
          if (
            item.workingStateKeepTime != undefined &&
            item.workingStateKeepTime != null
          ) {
            outputString =
              this.machineStateText[item.machineWorkingState] +
              " (" +
              this.timeChange(item.workingStateKeepTime) +
              ")";
          } else {
            //不显示时间
            outputString = this.machineStateText[item.machineWorkingState];
          }
          break;
      }
      return outputString;
    },

    /*
            状态持续时间：
            <60s,显示 x秒.
            <1小时,显示x分x秒.
            <24小时,显示 xx.xx小时.
            >=24小时,显示  xxx天xx.xx小时.
            */
    timeChange(input) {
      // input = 4 / 3 //调试时候打开它
      // input = 60 *  12 / 11 //调试时候打开它
      // input = 60 * 60 * 12 / 11 //调试时候打开它
      // input = 60 * 60 * 24 * 4 / 3 //调试时候打开它

      let outputString = "";
      if (input < 60) {
        outputString = input.toFixed(2) + "秒";
      } else if (input >= 60 && input < 60 * 60) {
        outputString =
          Math.trunc(input / 60) + "分" + (input % 60).toFixed(0) + "秒";
      } else if (input >= 60 * 60 && input < 60 * 60 * 24) {
        outputString = (input / (60 * 60)).toFixed(2) + "小时";
      } else {
        outputString =
          Math.trunc(input / (60 * 60 * 24)) +
          "天" +
          (input / (60 * 60 * 24) - Math.trunc(input / (60 * 60 * 24))).toFixed(
            2
          ) +
          "小时";
      }
      return outputString;
    },
    //显示 状态持续时间 -end

    //取到工人信息
    getWorkInfo() {
      const item = this.item;

      // console.log('item.workers[0].validTime=', item.workers[0].validTime)
      // console.log('item.workers[0].totalTime=', item.workers[0].totalTime)

      if (item.workers[0] != undefined) {
        if (
          item.workers[0].validTime != undefined &&
          item.workers[0].totalTime != undefined
        ) {
          if (
            item.workers[0].validTime != 0 &&
            item.workers[0].totalTime != 0
          ) {
            return (
              item.workerName +
              " (" +
              (
                (item.workers[0].validTime * 100) /
                item.workers[0].totalTime
              ).toFixed(2) +
              "%)"
            );
          } else if (
            item.workers[0].validTime == 0 ||
            item.workers[0].totalTime == 0
          ) {
            //liuqy: 有1个为0则显示0.00%
            return item.workerName + " (0.00%)";
          } else {
            return item.workerName;
          }
        } else {
          return item.workerName;
        }
      } else {
        return item.workerName;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#chart,
#order,
#timeline {
  // color: rgb(28, 191, 202);
  color: #ffffff;
  font-size: 16px;
  float: right;
  cursor: pointer;
}
.header {
  display: flex;
  justify-content: space-between;
  padding-bottom: -8px;
}
#order,
#timeline {
  margin-right: 2px;
}

p {
  line-height: 0.8;
  font-size: 13.4px;
}

.machineNumber {
  // cursor: pointer;
  font-weight: bold;
  font-size: 28px;
  line-height: 1;
}

.gray_back ::v-deep .el-card__header {
  background: #82848a;
  color: #ffffff;
  padding: 8px 8px 8px 8px;
}

.green_back ::v-deep .el-card__header {
  background: #19be6b;
  color: #ffffff;
  padding: 8px 8px 8px 8px;
}

.orange_back ::v-deep .el-card__header {
  background: #f29100;
  color: #ffffff;
  padding: 8px 8px 8px 8px;
}

.red_back ::v-deep .el-card__header {
  background: #dd6161;
  color: #ffffff;
  padding: 8px 8px 8px 8px;
}
</style>
